import React from 'react';
import { useTranslation } from 'react-i18next';

import { InfoBox } from '../../info-box/info-box';
import { ButtonContainer } from '../styled/button-container';
import { GoToLoginPageButton } from './go-to-login-page-button';

const FetchRequestTokenError = () => {
  const { t } = useTranslation();

  return (
    <>
      <InfoBox color="red" leftIcon={{ icon: ['fad', 'exclamation'] }}>
        {t('unexpectedErrorWithSupport', { ns: 'common' })}
      </InfoBox>

      <ButtonContainer direction="row" justifyContent="flex-end">
        <GoToLoginPageButton color="primary" variant="contained" />
      </ButtonContainer>
    </>
  );
};

export { FetchRequestTokenError };
